import { useGetFilter } from "hooks/useSearchParamsObj";
import SearchInput from "./SearchInput";
import { Space } from "antd";
import ExportExcelButton from "./ExportExcelButton";
import CreateButton from "./CreateButton";
import { DynamicObjectType } from "types/commons";
import { FilterV2Styles } from "./styles";
import { useTranslation } from 'react-i18next';

interface IFilterV2Props {
   hasSearch?: boolean;
   placeholderSearch?: string;
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
   customActions?: any;
   hasExport?: boolean;
   layoutButtonCreate?: string;
   hasCreate?: boolean;
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
   exportExcelQuery?: any;
   resource?: string;
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
   excelName?: any;
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
   isExportWithFilter?: any;
   resourceFilter?: DynamicObjectType;
   createHeader?: string;
   gotoCreatePage?: () => void;
   searchPlaceholder?: string;
}

export default function FilterV2({
   hasSearch = true,
   placeholderSearch,
   customActions,
   hasExport = true,
   layoutButtonCreate = 'non-inline',
   hasCreate = true,
   exportExcelQuery,
   resource,
   excelName,
   isExportWithFilter,
   resourceFilter,
   createHeader,
   gotoCreatePage,
}: IFilterV2Props) {
   const { t } = useTranslation();
   const { searchParams, setSearchParams } = useGetFilter();

   const handleTextSearch = (value) => {
      if (searchParams.get('q') !== value) {
         searchParams.delete('page');
         searchParams.delete('pageSize');
         if (value) {
            searchParams.set('q', value);
         } else {
            searchParams.delete('q');
         }
         setSearchParams(searchParams);
      }
   }

   return (
      <FilterV2Styles>
         {hasSearch ? (
            <SearchInput
               defaultValue={searchParams.get('q')}
               onTextSearch={handleTextSearch}
               placeholder={t(placeholderSearch)}
            />
         ) : (
            <div style={{ flex: 1 }} />
         )}
         {(customActions || hasExport || (layoutButtonCreate !== 'inline')) && (
            <Space size={10}>
               {customActions}
               {hasExport && exportExcelQuery && (
                  <div className="mx-12">
                     <ExportExcelButton
                        resource={resource}
                        excelName={excelName}
                        isExportWithFilter={isExportWithFilter}
                        resourceFilter={resourceFilter}
                        exportExcelQuery={exportExcelQuery}
                     />
                  </div>
               )}
               {hasCreate && layoutButtonCreate !== 'inline' && (
                  <CreateButton
                     header={createHeader}
                     gotoCreatePage={gotoCreatePage}
                  />
               )}
            </Space>
         )}
      </FilterV2Styles>
   )
}